import React from 'react';

function NoteIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7931 8.31606C13.7931 8.75648 13.4187 9.19689 12.8571 9.19689H6.39901C5.93103 9.19689 5.46305 8.84456 5.46305 8.31606C5.46305 7.78756 5.83744 7.43523 6.39901 7.43523H12.8571C13.4187 7.52332 13.7931 7.87565 13.7931 8.31606ZM12.9507 15.1865H6.39901C5.93103 15.1865 5.46305 15.5389 5.46305 16.0674C5.46305 16.5959 5.83744 16.9482 6.39901 16.9482H12.8571C13.3251 16.9482 13.7931 16.5959 13.7931 16.0674C13.7931 15.5389 13.4187 15.1865 12.9507 15.1865ZM6.39901 13.0725H10.4236C10.8916 13.0725 11.3596 12.7202 11.3596 12.1917C11.3596 11.6632 10.9852 11.3109 10.4236 11.3109H6.39901C5.93103 11.3109 5.46305 11.6632 5.46305 12.1917C5.46305 12.7202 5.93103 13.0725 6.39901 13.0725ZM21 9.54922V18.4456C21 19.8549 19.7833 21 18.2857 21H5.36946C3.49754 21 2 19.5907 2 17.9171V4.88083C2 4.44041 2.37438 4 2.93596 4H16.5074C16.9754 4 17.4434 4.35233 17.4434 4.88083V7.0829H18.3793C19.7833 6.99482 21 8.1399 21 9.54922ZM5.36946 19.3264H15.7586C15.665 19.0622 15.5714 18.7979 15.5714 18.4456V5.67358H3.77833V17.9171C3.77833 18.7098 4.4335 19.3264 5.36946 19.3264ZM19.2217 9.54922C19.2217 9.10881 18.8473 8.66839 18.2857 8.66839H17.3498V18.4456C17.3498 18.886 17.7241 19.3264 18.2857 19.3264C18.8473 19.3264 19.2217 18.9741 19.2217 18.4456V9.54922Z"
        fill="#FF8A00"
      />
    </svg>
  );
}

export default NoteIcon;
